import { PropsWithChildren } from 'react'

import { Section } from 'components'

import styles from './Tile.module.scss'

export interface TileContentProps {
  days: number
  translate: (key: string) => string
}

interface TileProps extends PropsWithChildren {
  className: string
  days: number
  tileKey: string
  translate: (key: string, options?: Record<string, unknown>) => string
}

const Tile = ({ children, className, days, tileKey, translate }: TileProps) => (
  <div className={[styles.tile, className].join(' ')}>
    <Section
      divider={false}
      info={translate(`${tileKey}.info`)}
      name={translate(`${tileKey}.title`)}
      period={translate('lastDays', { days })}
    />
    {children ?? <div className={styles.empty}></div>}
  </div>
)

export default Tile
